import React, { useEffect, useState } from "react";
import { storage } from "../../firebase";
import { ref, listAll, ListResult } from "firebase/storage";
import "./Photography.css";
import PhotographyWheel from "./PhotoWheel";

function Photography(): JSX.Element {
    document.title = "Tomas Ordoenz - Photography";
    const [collectionNames, setCollectionNames] = useState<string[]>([]);

    useEffect(() => {
        const fetchCollectionNames = async () => {
            // Get collection names from Photography folder
            try {
                const storageRef = ref(storage, "Photography");
                const collectionList: ListResult = await listAll(storageRef);
                const names: string[] = collectionList.prefixes.map((item) => item.name);
                setCollectionNames(names);
            } catch (error) {
                console.error("Error fetching collection names: ", error);
            }
        };

        fetchCollectionNames();
    }, []);

    return (
        <div className="photography-page">
            {collectionNames.map((collectionName) => (
                <PhotographyWheel key={collectionName} collection={collectionName} />
            ))}
        </div>
    );
}

// function Photography() {
//     document.title = "Tomas Ordonez - Photography";
//     return (
//         <div className="photography-page">
//             <PhotographyWheel collection="portugal" />
//             <PhotographyWheel collection="flowers" />
//         </div>
//     );
// }
export default Photography;
